import IconLogoDarkTheme from '@shared/icons/IconLogoDarkTheme';
import IconGoogle from '@shared/icons/IconGoogle';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { login, useLogin } from '@app/queries/user/useLogin';
import { TextInput } from '@shared/uikit/input-text';
import { GrayButton } from '@shared/uikit/button';

const Login = () => {
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [invalid, setInvalid] = useState<boolean>(false);
  const navigate = useNavigate();

  const { login, isError, error } = useLogin();

  const onLogin = async () => {
    try {
      const token = await login({ username, password });
      await localStorage.setItem('tokens', JSON.stringify({ access_token: token.access_token }));
    } catch (e) {
      setInvalid(true);
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const returnURL = params.get('returnURL');

    if (!returnURL || returnURL === '/' || returnURL === '/home') {
      return navigate('/via-btc/main');
    }

    setInvalid(false);
    return navigate('' + returnURL);
  };

  return (
    <div className="flex items-center justify-center h-full">
      <div>
        <div className="flex items-center justify-center gap-[10px] mb-[20px]">
          <div className="w-[33px] h-[33px]">
            <IconLogoDarkTheme />
          </div>
          <span className="top-[10px] left-[69px] text-[18px] font-black">INTERHASH</span>
        </div>
        <div className="font-semibold text-4.90xl mb-[40px] text-center">
          Statistics database Interhash
        </div>
        <div className="text-center text-1xl font-medium mb-[20px]">Вход в систему</div>
        <div className="w-[70%] m-auto mb-[20px]">
          <TextInput
            width="100%"
            placeholder="Email"
            value={username}
            onChange={setUsername}
            invalid={invalid}
          />
        </div>
        <div className="w-[70%] m-auto mb-[20px]">
          <TextInput
            width="100%"
            placeholder="Пароль"
            value={password}
            onChange={setPassword}
            invalid={invalid}
          />
        </div>
        <div className="w-[70%] m-auto mb-[20px]">
          <GrayButton title="Войти" onClick={() => onLogin()} />
        </div>
        <div className="flex justify-center cursor-pointer">
          <span className="p-[12px] bg-red rounded-[25px] bg-[#413E47]">
            <IconGoogle />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Login;
